import { connectListView, ListView } from "../../../UI/view/list-view";
import { liquidBillingManualDS } from "./liquid-billing-datasource";
import { CreateTransfer, CreateTransferDataSource } from "./liquid-create-transfer";
import { liquidBillingListColumns, liquidBillingListToolbar, liquidListFilters } from "./liquid-invoice-list";

export const liquidBillingManualList = {
  name: 'liquidBillingManualList',
  filters: liquidListFilters,
  columns: liquidBillingListColumns,
  additionalModals: [
    {
      form: CreateTransfer,
      repository: CreateTransferDataSource,
      name: 'createTransfer',
      title: 'Create Transfer',
    }
  ],
  toolbar: liquidBillingListToolbar('liquidBillingManualList'),
} as ListView;

export const [LiquidBillingManualList, LiquidBillingInvoiceDataSource] = connectListView(liquidBillingManualList, liquidBillingManualDS);